import React, { useEffect } from "react";
import TableSortLabel from "@mui/material/TableSortLabel";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import "./table.css";

const EnhancedTableHead = ({ column, order, orderBy, onRequestSort }) => {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {column.map((ele, index) => {
          if (index === 0) {
            return <TableCell key={ele.id}>Sr. No</TableCell>;
          } else {
            return (
              <TableCell
                key={ele.id}
                sortDirection={orderBy === ele.id ? order : false}
              >
                <TableSortLabel
                  active={orderBy === ele.id}
                  direction={orderBy === ele.id ? order : "asc"}
                  onClick={createSortHandler(ele.id)}
                >
                  {ele.label}
                </TableSortLabel>
              </TableCell>
            );
          }
        })}
      </TableRow>
    </TableHead>
  );
};

function TableScrollDiv({
  id = "",
  className = "",
  column = [],
  loading = false,
  sortable = false,
  setOrderBy = () => {},
  orderBy = "",
  order = "desc",
  setOrder = () => {},
  getSystemLogg = () => {},
  ...props
}) {
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  useEffect(() => {
    getSystemLogg();
  }, [order, orderBy]);

  return (
    <div className={`_tableScroll ${className}`}>
      <TableContainer
        sx={{
          maxHeight: "100%",
          overflow: loading ? "hidden" : "visible",
        }}
      >
        <Table stickyHeader id={id}>
          {sortable ? (
            <EnhancedTableHead
              column={column}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
          ) : (
            <TableHead>
              <TableRow>
                {column.map((ele, index) => (
                  <TableCell key={index}>
                    {/* {index} */}
                    {ele}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          )}
          <TableBody>{props.children}</TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default TableScrollDiv;
